import { CustomerCommunicationType } from '@eigtech/claims-v2-types'
import { startCase } from 'lodash-es'

const customerCommunicationTypeLabelRecord: Partial<Record<CustomerCommunicationType, string>> = {
  customerContactedEmail: 'Customer Contacted - Email',
  customerContactedLvm: 'Customer Contacted - Left Voicemail',
  customerContactedNoVoicemail: 'Customer Contact Attempted - No Voicemail',
  customerContactedSms: 'Customer Contacted - SMS',
  initialCustomerContactAttempted: 'Customer Contact Attempted',
  initialCustomerContactFailed: 'Customer Contact Failed',
  initialCustomerContactSuccess: 'Customer Contact Success',
}

export const getCustomerCommunicationTypeLabel = (
  customerCommunicationType: CustomerCommunicationType
) =>
  customerCommunicationTypeLabelRecord[customerCommunicationType] ??
  startCase(customerCommunicationType)
